import request from 'api/request';

export default function readUsageRoute(userId) {
  return request({ url: `/users/${userId}/usage` });
}
